import { Component, OnInit,Input,EventEmitter,NgZone,ViewChild } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { IniciativaDetalle, TablaMisIniciativas, Impactos,GrupoAplicativo,Aplicativos } from '../../interfaces/interfaces';
import { Paginado } from '../../models/paginado';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from '../../services/data.service';
import { Router } from '@angular/router';
import{ ConfirmListadoIniciativasComponent} from 'src/app/components/shared/confirm-listado-iniciativas/confirm-listado-iniciativas.component';
import{ ModalConsultaIniciativaComponent} from 'src/app/components/modal-consulta-iniciativa/modal-consulta-iniciativa.component';
import { MatDialog} from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { element } from 'protractor';
import { DialogCambioTipoIniciativaComponent } from 'src/app/components/dialog-cambio-tipo-iniciativa/dialog-cambio-tipo-iniciativa.component';
import { DialogAsignaEnlaceComponent } from 'src/app/components/dialog-asigna-enlace/dialog-asigna-enlace.component';

@Component({
  selector: 'app-mis-iniciativas',
  templateUrl: './mis-iniciativas.component.html',
  styleUrls: ['./mis-iniciativas.component.scss']
})
export class MisIniciativasComponent implements OnInit {
  // Animacion tabla
  animacionRecargaTabla: string;
  // Alerta periodo de envio
  esPeriodoEnvio: boolean;
  consultar: boolean;
  emailUser: string;
  userName: string;
  VIP: boolean;
  listaTipoIniciativa
  tablaIniciativas: TablaMisIniciativas[] = [];
  arrayImpactosConsulta: Impactos[]=[];
  paginaActual: Paginado=new Paginado();
  iniciativaSeleccionada: IniciativaDetalle;
  botonPresionado:number;
  mostrarEdicion:boolean=false;
  mostrarConsulta:boolean=false;
  mostrarTabla: boolean=true;
  nuevoSisFormDatos: FormGroup;
  fechaActual: number;
  subiendoProcesoActual = false;
  procesoActualError = false;
  tipoIniciativa:number;
  fechaInicio:string;
  fechaFin:string;
  termino:string;
  loadingGeneral: boolean = true;
  tablaHistorial:any[]=[];
  mostrardescargarArchivoPA:boolean=false;
  mostrardescargarArchivoPP:boolean=false;
  mostrardescargarArchivoAN:boolean=false;
  nombreArchivoPP:string;
  nombreArchivoPA:string;
  nombreArchivoAN:string;
  idProceso:number;
  gruposAplicativos: GrupoAplicativo[];
  tiposAplicativos: Aplicativos[];
  idRolSeleccionado:number;
  nombreRol:string;
  varMostraCalendario:boolean=false;
  varMostraCalendario2021:boolean=false;
  showHistorialAlert: boolean = false;


  listaPeriodo: any[]=[];
  listaPeriodo2021: any[]=[];
  isLoading:boolean=false;
  totalRegistros:number;
  folio;
  allRoles:any;
  correo:any;
  r1:any;
  r2:any;
  aceptaCambioReq:boolean=false;
  aceptaCambioEnlace:boolean=false;
  filter:string;
  cambiosForm: FormGroup;

  public globalSub: Subscription;
  iniciativa: any;

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private notifier: NotifierService,
    private zone: NgZone,
    private router: Router,
    public dialog:MatDialog,
    private _formBuilder: FormBuilder

  ) {

    // Obtener los aplicativos
    this.dataService.obtenerGruposSistemas().subscribe(data => {
      this.gruposAplicativos = data['data'];
    });

    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      //return this.emailUser;
    });
    this.authService.userName.subscribe((userName: string) => {
      {this.userName = userName}
      //return this.emailUser;
    });
    
    this.authService.isVIP.asObservable().subscribe((res) => {
      this.VIP = res;
    });

    this.animacionRecargaTabla = 'animated fadeInUp';
    this.globalSub=this.authService.onGetAllRolesUsuario().subscribe(async (resp) => {
      this.allRoles = await JSON.parse(resp)
    });
    this.globalSub=this.authService.onGetCorreo().subscribe(async (resp) => {
      this.correo = await resp;
    });
  }

  async ngOnInit() {
    /* funcionalidad revisa roles */
    //console.log(this.allRoles[0]);
    //this.allRoles[0]=3
    this.r1 = this.filterRl(this.allRoles, 1);
    this.r2 = this.filterRl(this.allRoles, 2);
    (this.r1.length==1 && this.r2.length==1 )?this.aceptaCambioReq=true:this.aceptaCambioReq=false;
    (this.r1.length==1 || this.r2.length==1 )?this.aceptaCambioEnlace=true:this.aceptaCambioEnlace=false;

    if(this.listaPeriodo.length==0)
    {
      this.cargarPeriodosEnvio();
    }
    //Nos subscribimos al método para el rol seleccionado
    this.isLoading=true;
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res;
      if(this.correo && this.idRolSeleccionado!=13)
      {
        this.isLoading=true;
        this.paginaActual= new Paginado();
        this.paginaActual.numeroPagina = 1;
        this.paginaActual.email=this.correo;
        this.paginaActual.fechaInicio="";
        this.paginaActual.fechaFin="";
        this.paginaActual.termino="";
        this.paginaActual.rolUserlogin=this.idRolSeleccionado;
        this.quitarFiltro();
      }
    });
  
    this.paginaActual = new Paginado();
    this.paginaActual.numeroPagina = 1;
    this.authService.user.subscribe((user: string) => {
      {this.correo = user}
       this.dataService.esPeriodoEnvios().subscribe(
        data=>{
          this.esPeriodoEnvio=data['objData'];
        }
      );
      this.paginaActual.email=this.correo;
      this.paginaActual.fechaInicio="";
      this.paginaActual.fechaFin="";
      this.paginaActual.termino="";
      this.paginaActual.botonBuscar=false;
      this.paginaActual.rolUserlogin=this.idRolSeleccionado;
      
      if(this.correo)
      {
        
      //Recuperamos el paginado
      let paginadoLocal= JSON.parse(localStorage.getItem('paginado'));
      if(paginadoLocal)
      {
        this.paginaActual=paginadoLocal;
        this.fechaInicio=this.paginaActual.fechaInicio;
        this.fechaFin=this.paginaActual.fechaFin;
        this.folio=this.paginaActual.folio_iniciativa;
        this.filter=this.paginaActual.termino;
        this.paginaActual.botonBuscar=true;
      }
        this.cargarIniciativas();
      }
    // Subir a tope de pagina
    this.scrollInicio();
    });
  }

  changeStatus(accion, obj) {
    this.botonPresionado=11;
    obj.action = accion;
    obj.rolSeleccionado=this.idRolSeleccionado;
    obj.userLogin=this.correo;
    obj.mensaje=' Se perderá la información que no sea compatible entre ambos tipos de iniciativa.'
    const dialogRefEliminar = this.dialog.open(DialogCambioTipoIniciativaComponent, {
      width: '440px',
      height: '380px',
      data: obj
    }).afterClosed().subscribe(result => {
      this.botonPresionado=null;
      this.onSaveStatus(result,true);
    });
  }


  changeEnlace(accion, obj) {
    this.botonPresionado=11;
    obj.action = accion;
    obj.rolSeleccionado=this.idRolSeleccionado;
    obj.userLogin=this.correo;
    obj.mensaje=''
    const dialogRefEliminar = this.dialog.open(DialogAsignaEnlaceComponent, {
      width: '440px',
      height: '300px',
      data: obj
    }).afterClosed().subscribe(result => {
      this.botonPresionado=null;
      this.onSaveEnlace(result,obj);
    });
  }

  
  onSaveEnlace(body,obj){
    var b;
    if(this.idRolSeleccionado==1)
    {
      b={
        "id_iniciativa":body.id_iniciativa,
        "userlogin":body.userlogin,
        "rolUserLogin":this.idRolSeleccionado,
        "id_tipoIniciativa":2,
        "id_tipoIniciativaANT":obj.id_tipoIniciativa,
      }
    }else if(this.idRolSeleccionado==2){
      b={
        "id_iniciativa":body.id_iniciativa,
        "userlogin":body.userlogin,
        "rolUserLogin":this.idRolSeleccionado,
        "id_tipoIniciativa":1,
        "id_tipoIniciativaANT":obj.id_tipoIniciativa,
      }
    }
    body.enviar_correo=1;
    this.dataService.updateEnlaceIniciativa(body).subscribe(res=>{
      if(res['status']=="OK"){
        this.onSaveStatus(b,false);
        this.notifier.notify(
          'success',
          ''+res['notificaciones']
        );
      }else{
        this.notifier.notify(
          'error',
          'Ha ocurrido un error. Verifique su conexión de red o contacte al administrador.'
        );
      }
      this.cargarIniciativas()
    },err=>{
      this.notifier.notify(
        'error',
        'Ha ocurrido un error. Verifique su conexión de red o contacte al administrador.'
      );
    })
  }

  onSaveStatus(body,noti){
    this.dataService.cambioRequerimientos(body).subscribe(res=>{
      if(noti){
        if(res['status']=="OK"){
          this.notifier.notify(
            'success',
            ''+res['notificaciones']
          );
        }else{
          this.notifier.notify(
            'error',
            'Ha ocurrido un error. Verifique su conexión de red o contacte al administrador.'
          );
        }
      }  
        this.cargarIniciativas()
    },err=>{
      this.notifier.notify(
        'error',
        'Ha ocurrido un error. Verifique su conexión de red o contacte al administrador.'
      );
    })
  }
  
  //Método para redirigir a la pantalla según el boton presionado 
  onSubmitReactive(btnId:number, id_iniciativa:number, folio?:number,estatus?:number)
  {
    this.botonPresionado=btnId;
    //Mandamos el boton precionado en la tabla
    window.localStorage.removeItem ("opcionTabla");
    window.localStorage.setItem ("opcionTabla", btnId.toString());

    //Opcion de editar y consultar
    if(this.botonPresionado==1 || this.botonPresionado==2)
    {
      localStorage.removeItem ("editarIniciativaId");
      localStorage.setItem ('editarIniciativaId', id_iniciativa.toString());
      //Obtengo el tipo de solicitud
      this.detallesIniciativa(id_iniciativa);
    }
    //Opcion de historial
    if(this.botonPresionado==3)
    {
       this.historialIniciativa(id_iniciativa, folio);
    }
    //Opcion de enviar iniciativa
    if(this.botonPresionado==4)
    {
       this.enviarIniciativa(id_iniciativa);
    }
    //Opcion de autorizacion fuera de periodo iniciativa
    if(this.botonPresionado==5)
    {
       this.autorizacionFueraPeriodo(id_iniciativa,this.paginaActual.email);
    }

    //Opcion de duplicar iniciativa
    if(this.botonPresionado==6)
    {
       this.duplicarIniciativa(id_iniciativa, folio, this.paginaActual.email);
    }
    //Opcion de cancelación iniciativa
    if(this.botonPresionado==7)
    {
       this.cancelacionIniciativa(id_iniciativa, folio ,this.paginaActual.email);
    }
    //Opcion de eliminar iniciativa
    if(this.botonPresionado==8)
    {
       this.eliminarIniciativa(id_iniciativa, folio,this.paginaActual.email);
    }
    //Opcion de contactos iniciativa
    if(this.botonPresionado==9)
    {
       this.contactosIniciativa(id_iniciativa, folio);
    }

    //Opcion de comentarios iniciativa
    if(this.botonPresionado==10)
    {
       this.comentariosIniciativa(id_iniciativa, folio,estatus);
    }
    
  }

  mostraCalendario()
  {
    this.varMostraCalendario=true;
    this.varMostraCalendario2021=false;

  }

  mostrarCalendario2021()
  {
    this.varMostraCalendario2021=true;
    this.varMostraCalendario=false;
    
  }

  filterRl = (arr,idrol) => (arr).filter(element => (parseInt(element)) == idrol)

  cargarPeriodosEnvio()
  {
      this.dataService.getListPeriodosEnvio().subscribe(
        data => {
          data['data'].forEach(element => {
            var arrayDeCadenasInicio =element['fechaInicio_periodoEnvio'].split('-');
            let valores={
              'year':parseInt(arrayDeCadenasInicio[0])
            }
            if(valores.year==2020)
            {
              this.listaPeriodo.push(element);
            }
            else{
              this.listaPeriodo2021.push(element);
            }
          });
          
        },
        error => {
          console.error(error);       
        }
      );
  }
  
  //Metodo para ordenar por director de area
  sortingDirArea()
  {
    this.paginaActual.orderByGeneral=false;
    this.paginaActual.orderBySubse=true;
    this.paginaActual.orderByArea=true;
    this.cargarIniciativas();
  }

  //Metodo para ordenar por director de area
  sortingDirGral()
  {
    this.paginaActual.orderBySubse=false;
    this.paginaActual.orderByArea=false;
    this.paginaActual.orderByGeneral=true;
    this.cargarIniciativas();
  }

  //Metodo para ordenar por director de area
  sortingSubsecretario()
  {
    this.paginaActual.orderBySubse=true;
    this.paginaActual.orderByArea=false;
    this.paginaActual.orderByGeneral=false;
    this.cargarIniciativas();
  }

  cancelar()
  {
    this.mostrarEdicion=false;
    this.mostrarTabla=true;
    this.nuevoSisFormDatos.reset();
  }

  
  //Método para limpiar los filtros
  quitarFiltro() 
  {
    let termino;
    localStorage.removeItem('paginado');
    this.filter='';
    if(this.paginaActual.termino)
    {
       termino= this.paginaActual.termino;
    }
    this.paginaActual= new Paginado;
    this.fechaFin="";
    this.fechaInicio="";
    this.folio="";
    this.paginaActual.numeroPagina = 1;
    this.paginaActual.email=this.correo;
    this.paginaActual.fechaInicio="";
    this.paginaActual.fechaFin="";
    //this.paginaActual.termino=termino;
    this.paginaActual.botonBuscar=false;
    this.paginaActual.rolUserlogin=this.idRolSeleccionado;
    this.cargarIniciativas();
  }

  //Metodo para actualizar el grid
  actualizarGrid()
  {
    this.cargarIniciativas();
  }

  onSubmit() 
  {
    //Enviar la data al service
    this.dataService.nuevoSistema(this.nuevoSisFormDatos.value).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Nueva iniciativa registrada correctamente.'
          );
          this.mostrarEdicion=false,
          this.mostrarTabla=true;
          this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
        }
        else{
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar registrar la iniciativa. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }

  cargarIniciativas() {
    this.loadingGeneral = true;
    this.dataService.obtenerIniciativasUsuario(this.paginaActual).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.notifier.notify('error', 'No se han pordido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
        }
        else{
          this.tablaIniciativas = data['data'];
          this.totalRegistros=data['total_registros'];
          if(data['data'].length < 1)
          {
            this.isLoading=false;
            this.loadingGeneral = false;
          }else{
            this.isLoading=false;
            this.loadingGeneral = false;
          }

        }
      }
    );
  }

  //Método que recupera los datos de las iniciativas
  cargarAnteriores() {
    this.loadingGeneral=true;
    this.paginaActual.numeroPagina--;
    //this.paginaActual.numeroPagina-1;
    this.dataService.obtenerIniciativasUsuario(this.paginaActual).subscribe(
      data => {
        if (data['data'].length > 0) 
        {
          this.tablaIniciativas = data['data'];
        }
        this.loadingGeneral=false;

      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar tus iniciativas anteriores. Verifica tu conexión de red.'
        );
      }
    );
  }

  

  cargarSiguientes() 
  {
    this.loadingGeneral = true;
    this.paginaActual.numeroPagina++;
    this.dataService.obtenerIniciativasUsuario(this.paginaActual).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.')
        }
        else{
          this.tablaIniciativas = data['data'];
          if(data['data'].length < 1)
          {
            this.loadingGeneral = false;
            this.paginaActual.numeroPagina--;
          }else{
            this.loadingGeneral = false;
            //this.paginaActual.numeroPagina--;
          }

        }
      }
    );
  }

  recargarTablaIniciativas(evento: number) {
    this.dataService.obtenerIniciativasUsuario(this.paginaActual).subscribe(
      data => {
        if (data['data'] && data['data'].length > 0) {
          this.tablaIniciativas = data['data'];
        } else {
          this.paginaActual.numeroPagina--;
        }
        this.animarTablaRecargar();
      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar tus iniciativas. Contacta al administrador.'
        );
      }
    );
  }

  private animarTablaRecargar() {
    this.animacionRecargaTabla = '';
    this.animacionRecargaTabla = 'animated pulse';
  }

  scrollInicio() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }


  //Detalles de la iniciativa
  detallesIniciativa(id:number)
  {
    this.dataService.detalleIniciativa(id).subscribe(data => {
      if (data['objData']) 
      {
        this.tipoIniciativa=data['objData']['id_tipoIniciativa'];
        //Redireccionamos según el tipo de iniciativa
        if( this.tipoIniciativa==1)
        {
          this.zone.run(() => this.router.navigate(['./nuevo-sistema']));
          this.botonPresionado=0;
        }
        else{
          this.zone.run(() => this.router.navigate(['./cambios-funcionalidades']));
          this.botonPresionado=0;

        }

      }
      else{
        this.tipoIniciativa=0;
      }
    });
  }

  detalleIniciativaModal(id:number, id_tipoIniciativa:number)
  {
    this.consultar=true;
    localStorage.removeItem ("editarIniciativaId");
    localStorage.setItem ("editarIniciativaId", id.toString());
    if(!this.botonPresionado)
    {
      this.zone.run(() => this.router.navigate(['./consulta-iniciativa']));
    }
    
  }


  aplicativosAreas(idGrupo: number) 
  {
    this.dataService.obtenerAplicativos(idGrupo).subscribe(
      data => {
        if (data['data']) {
          this.tiposAplicativos = data['data'];
           /*Obtenemos el area dueña de la aplicacion*/
          for(let v of this.tiposAplicativos)
          {
            if(v.id_aplicacion==this.iniciativaSeleccionada.id_aplicacion){
              this.iniciativaSeleccionada.nombreAplicacion=v.nombre_aplicacion;
            }
          }
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  //Método para enviar la iniciativa
  enviarIniciativa(id:number)
  {
    //Mostramos la ventana de confirmación
      let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data: {opcion:4},disableClose:true,width: '450px'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.botonPresionado=0;
        }
        else{
          this.dataService.enviarIniciativa(id,this.correo,this.idRolSeleccionado).subscribe( 
            data => {
              if (data['alert']==0)
              {
                this.notifier.notify('success', 'Iniciativa enviada correctamente Folio:'+ data['objData']);
                //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
                this.cargarAnteriores();

                //this.notifier.notify('success', 'Nueva iniciativa para cambios en funcionalidades editada correctamente.');
              }
              else{
                this.notifier.notify('error',data['errorMessage']);
              }
            },
            error => {
              console.error(error);
            }
          );
          this.botonPresionado=0;
        }
    });
  }

  //Método para autorización fuera de periodo
  autorizacionFueraPeriodo(id:number,email:string)
  {
    ////endPont para validar información de la iniciativa, recuperamos los valores de la iniciativa
    this.dataService.detalleIniciativa(id).subscribe(data => {
      let infoIniciativa=data['objData'];
      this.validacionIniciativas(data['objData'].id_tipoIniciativa,infoIniciativa);
      if(this.cambiosForm.valid)
      {
         
      let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data: {id_iniciativa:id,userLogin:email,rolUserLogin:this.idRolSeleccionado,opcion:5},disableClose:true});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.botonPresionado=0;
        }
        else{
          
          this.notifier.notify(
            'success',
            'Solicitud enviada correctamente.'
          );
        /*  let datos={
            'id_iniciativa':id,
            'userlogin':email,
            'justificacion':result,
            'rolUserlogin':this.idRolSeleccionado
          }
          this.dataService.solicitudEnvioFueraPeriodo(datos).subscribe(
            data => {
              if (data['objData']) 
              {
                this.notifier.notify(
                  'success',
                  'Solicitud enviada correctamente.'
                );
                this.cargarAnteriores();
                //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
              }
              else{
                this.notifier.notify(
                  'error',data['errorMessage']
                );

              }
            },
            error => {
              console.error(error);
              this.notifier.notify(
                'error',
                'Ha ocurrido un error al intentar enviar solicitud. Verifique su conexión de red o contacte al administrador.'
              );
            }
          );*/
          this.cargarAnteriores();
          this.botonPresionado=0;
        }
       });

    }//Form invalido
      else{
        this.notifier.notify(
          'error',
          'Existen algunos datos faltantes de la iniciativa. Favor de completar la información para poder enviar su solicitud.'
        );
        this.botonPresionado=0;
      }
     });

  } 


  
  //Método de validacion 
  private validacionIniciativas(tipoIniciativa:number, form:any)
  {
    switch (tipoIniciativa) 
    {
      //Nuevo sistema
      case 1:
          this.cambiosForm = this._formBuilder.group({
            id_iniciativa: [form.id_iniciativa],
            id_proceso: [form.id_proceso],
            folio_iniciativa:[form.folio_iniciativa],
            fechaEnvio_iniciativa:[form.fechaEnvio_iniciativa],
            id_tipoIniciativa: [form.id_tipoIniciativa],
            id_area : [form.id_area],
            id_aplicativo: [form.id_aplicativo],
            id_estatusIniciativa: [form.id_estatusIniciativa],
            nombre_iniciativa: [form.nombre_iniciativa, Validators.required],
            nombre_solicitante: [form.nombre_solicitante, Validators.required],
            email_solicitante: [form.email_solicitante, Validators.required],
            telefono_solicitante: [form.telefono_solicitante, Validators.required],
            extencion_solicitante: [form.extencion_solicitante],
            fechaTermino_iniciativa: [form.fechaTermino_iniciativa, Validators.required],
            justificacionFecha_iniciativa: [form.justificacionFecha_iniciativa, Validators.required],
            numeroTransacciones_iniciativa: [form.numeroTransacciones_Iniciativa, Validators.required],    
            solucionPropuesta_iniciativa: [form.solucionPropuesta_iniciativa, Validators.required],
            beneficiariosDirectos_iniciativa: [form.beneficiariosDirectos_iniciativa, Validators.required],
            beneficiariosImplementacion_iniciativa:[form.beneficiariosImplementacion_iniciativa, Validators.required],
            nombreProceso_iniciativa: [form.nombreProceso_iniciativa, Validators.required],
            doc_procesoActual: [form.doc_procesoActual, Validators.required],
            doc_procesoPropuesto: [form.doc_procesoPropuesto, Validators.required],
            docAnexos_iniciativas: [form.docAnexos_iniciativas],
            problematica_iniciativa: [form.problematica_iniciativa, Validators.required],
            id_dirgralSapSolicitante:[form.id_dirgralSapSolicitante, Validators.required],
            id_areaSapSolicitante:[form.id_areaSapSolicitante, Validators.required],
            jsonIniciativaImpacto:[form.jsonIniciativaImpacto, Validators.required],
         
          });
          break;
    //Cambio con cambio al proceso
      case 2:
          this.cambiosForm = this._formBuilder.group({
            id_iniciativa: [form.id_iniciativa],
            id_proceso: [form.id_proceso],
            //folio_iniciativa:[form.id_proceso],
            fechaEnvio_iniciativa:[form.fechaEnvio_iniciativa],
            id_tipoIniciativa: [form.id_tipoIniciativa],
            id_area : [form.id_area,Validators.required],
            id_aplicacion:[form.id_aplicacion,Validators.required],
            id_estatusIniciativa: [form.id_estatusIniciativa],
            implicaCambios: [form.implicaCambios],
            userlogin: [this.correo],
            rolUserlogin:[this.idRolSeleccionado],
            id_dirgralSapSolicitante: [form.id_dirgralSapSolicitante, Validators.required],
            id_areaSapSolicitante: [form.id_areaSapSolicitante, Validators.required],
            nombre_iniciativa: [form.nombre_iniciativa, Validators.required],
            nombre_solicitante: [form.nombre_solicitante, Validators.required],
            email_solicitante: [form.email_solicitante, Validators.required],
            telefono_solicitante: [form.telefono_solicitante, Validators.required],
            extencion_solicitante: [form.extencion_solicitante],
            fechaTermino_iniciativa: [form.fechaTermino_iniciativa, Validators.required],
            justificacionFecha_iniciativa: [form.justificacionFecha_iniciativa, Validators.required],
            //numeroTransacciones_iniciativa: [form.numeroTransacciones_iniciativa, Validators.required],    
            solucionPropuesta_iniciativa: [form.solucionPropuesta_iniciativa, Validators.required],
            nombreProceso_iniciativa: [form.nombreProceso_iniciativa, Validators.required],
            doc_procesoActual: [form.doc_procesoActual, Validators.required],
            doc_procesoPropuesto: [form.doc_procesoPropuesto, Validators.required],
            docAnexos_iniciativas: [form.docAnexos_iniciativas],
            problematica_iniciativa: [form.problematica_iniciativa, Validators.required],
            //dirGral_solicitante:[form.dirGral_solicitante, Validators.required],
            //direccionArea_solicitante: [form.direccionArea_solicitante, Validators.required]
          })
    
          break;
    //Cambio sin cambio al proceso
    case 3:
          this.cambiosForm = this._formBuilder.group({
            id_iniciativa: [form.id_iniciativa],
            id_area : [form.id_area,Validators.required],
            id_aplicacion:[form.id_aplicacion,Validators.required],
            id_tipoIniciativa: [form.id_tipoIniciativa],
            nombre_iniciativa: [form.nombre_iniciativa, Validators.required],
            nombre_solicitante: [form.nombre_solicitante, Validators.required],
            email_solicitante: [form.email_solicitante, Validators.required],
            telefono_solicitante: [form.telefono_solicitante, Validators.required],
            extencion_solicitante: [form.extencion_solicitante],
            fechaTermino_iniciativa: [form.fechaTermino_iniciativa, Validators.required],
            justificacionFecha_iniciativa: [form.justificacionFecha_iniciativa, Validators.required],
            problematica_iniciativa: [form.problematica_iniciativa, Validators.required],
            id_dirgralSapSolicitante: [form.id_dirgralSapSolicitante, Validators.required],
            id_areaSapSolicitante: [form.id_areaSapSolicitante, Validators.required],
            docAnexos_iniciativas: [form.docAnexos_iniciativas],
            implicaCambios: [form.implicaCambios],
            doc_procesoActual: [form.doc_procesoActual],
            doc_procesoPropuesto: [form.doc_procesoPropuesto],
           userlogin: [this.correo],
           rolUserlogin:[this.idRolSeleccionado]
          })
          break;
    }

  }

  
  //Método para enviar la iniciativa
  duplicarIniciativa(id:number, folio:number, email:string)
  {
    //Mostramos la ventana de confirmación
      let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data:{id_iniciativa:id,folio:folio,opcion:6},disableClose:true,width: '400px'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
         
        }
        else{
          this.dataService.duplicarIniciativa(id,email,this.idRolSeleccionado).subscribe(
            data => {
              if (data['objData']) 
              {
                this.notifier.notify(
                  'success',
                  'Se duplico correctamente.'
                );
                this.cargarIniciativas();
                this.botonPresionado=0;
                //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
              }
              else{
                this.notifier.notify(
                  'error',
                  data['notificaciones']
                );
                
              }
            },
            error => {
              this.notifier.notify(
                'error',
                'Ha ocurrido un error al intentar duplicar la iniciativa. Verifique su conexión de red o contacte al administrador.'
              );
            }
          );
          this.botonPresionado=0;
        }
    });

  }

   //Método para eliminar la iniciativa
   eliminarIniciativa(id:number, folio:number, email:string)
   {
     //Mostramos la ventana de confirmación
       let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data:{id_iniciativa:id,folio:folio,opcion:8},disableClose:true});
       dialogRef.afterClosed().subscribe(result => {
         if(result==false)
         {
          this.botonPresionado=0;

         }
         else{
          this.dataService.deleteIniciativa(id,email,this.idRolSeleccionado).subscribe(
            data => {
              if (data['objData']) 
              {
                this.notifier.notify(
                  'success',
                  'Se elimino correctamente.'
                );
                this.cargarIniciativas();
                //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
              }
              else{
                this.notifier.notify('error',data['errorMessage']);
                 
              }
            },
            error => {
              console.error(error);
              this.notifier.notify(
                'error',
                'Ha ocurrido un error al intentar eliminar la iniciativa. Verifique su conexión de red o contacte al administrador.'
              );
            }
          );

          this.botonPresionado=0;
           
         }
     }); 
   }

   //Método para cancelacion de iniciativa
  cancelacionIniciativa(id:number,folio:number ,email:string)
  {
      let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data:{opcion:7, folio:folio},disableClose:true,width: '600px'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.botonPresionado=0;
        }
        else{
          let datos={
            'id_iniciativa':id,
            'userlogin':email,
            'justificacion':result,
            'rolUserlogin':this.idRolSeleccionado
          }
          
          this.dataService.solicitudCancelacion(datos).subscribe(
            data => {
              if (data['objData']) 
              {
                this.notifier.notify(
                  'success',
                  'Solicitud enviada correctamente.'
                );
                this.cargarIniciativas();
              }
              else{
                
                this.notifier.notify(
                  'error',
                  data['errorMessage']
                );
              }
            },
            error => {
              this.notifier.notify(
                'error',
                'Ha ocurrido un error al intentar enviar solicitud. Verifique su conexión de red o contacte al administrador.'
              );
            }
          );
          this.botonPresionado=0;
          
        }
    });

  } 
  
  //Método para ver el historial de la iniciativa
  historialIniciativa(id:number, folio:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data:{id_iniciativa:id,opcion:3,folio:folio},disableClose:true,width: '1200px'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.botonPresionado=0;

        }
        else{
          this.botonPresionado=0;
        }
    });
  }

  //Método para los contactos de la iniciativa
  contactosIniciativa(id:number, folio:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data:{id_iniciativa:id,folio:folio,opcion:9},disableClose:true,height: '450px', width: '800px'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          this.botonPresionado=0;
        }
        else{
          this.botonPresionado=0;
        }
    });

  }


  //Método para los contactos de la iniciativa
  comentariosIniciativa(id:number, folio:number, estatus?:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasComponent,{data:{id_iniciativa:id,folio:folio,estatus:estatus,userName:this.userName,email:this.correo,idRol:this.idRolSeleccionado,opcion:10},disableClose:true,width:'1000%'});
      dialogRef.afterClosed().subscribe(result => {
        if(result==false)
        {
          
          this.loadingGeneral=true;
           //Marcamos como vistos los comentarios
           let valores={
             'id_iniciativa':id,
             'email_usuarioComentario':this.correo,
             'id_rol':this.idRolSeleccionado
           }
            this.dataService.marcarVistoComentarios(valores).subscribe(
              data => {
              },
              error => {
                console.error(error);
                this.notifier.notify(
                  'error',
                  'Ha ocurrido un error. Contacta al administrador.'
                );
              }
            );
            this.loadingGeneral=false;
            this.cargarIniciativas();
            this.botonPresionado=0;
        }
        else{
          let valores={
            'id_iniciativa':id,
            'email_usuarioComentario':this.correo,
            'id_rol':this.idRolSeleccionado
          }
           this.dataService.marcarVistoComentarios(valores).subscribe(
             data => {
             },
             error => {
               console.error(error);
               this.notifier.notify(
                 'error',
                 'Ha ocurrido un error. Contacta al administrador.'
               );
             }
           );
          this.cargarIniciativas();
          this.botonPresionado=0;
          
        }
    });
  }

  get estadoIniciativa(): string {
    if (this.iniciativa.id_estatusIniciativa === 16 && this.iniciativa.id_estatusIniciativa_anterior === 11) {
      return 'Corregir';
    }
    return this.iniciativa.nombre_estatusIniciativa;
  }
  

  //Método para aplicar el filtro 
  applyFilter(event: Event) 
  {
    const filterValue = (event.target as HTMLInputElement).value;
    this.paginaActual.numeroPagina=1;
    this.buscarIniciativas(this.paginaActual.numeroPagina,this.fechaInicio,this.fechaFin,filterValue.trim().toLocaleLowerCase());
    //this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  buscarIniciativas(pagina:number, fechaInicio:string, fechaFin:string ,valor?:string, folio?:string)
  {
    this.loadingGeneral = true;
    this.paginaActual.numeroPagina=pagina;
    this.paginaActual.termino=valor;
    this.paginaActual.fechaFin=fechaFin;
    this.paginaActual.fechaInicio=fechaInicio;
    this.paginaActual.botonBuscar=true;
    if(folio)
    {
      this.paginaActual.folio_iniciativa=folio;
    }
     //Paginado
     window.localStorage.setItem ("paginado", JSON.stringify(this.paginaActual));
    //this.loadingGeneral = true;
    this.dataService.obtenerIniciativasUsuario(this.paginaActual).subscribe(res => {
      if (res['errorMessage']) 
      {
        this.loadingGeneral = false;
        this.notifier.notify('error', 'No se han podido cargar las iniciativas. Revisa tu conexión de red e inténtalo de nuevo más tarde.');

      } else 
      {
        this.loadingGeneral = false;
        this.tablaIniciativas= res['data'];        
        this.totalRegistros=res['total_registros'];

    }});
  }
  
  abrirModalIniciativaConsulta(idIniciativa:number)
 { 
   const dialogRef = this.dialog.open(ModalConsultaIniciativaComponent,{data:{id_iniciativa:idIniciativa},disableClose:false, height: '580px',
   width: '800px'});
   dialogRef.afterClosed().subscribe(data => {
     if(data==false)
     {
     }
     else{
       //Mapeamos el idProceso y tipo
     }//Cerrar el else
   //Cerrar ventana modal
  });
}

//Método para descargar archivo excel
descargarArchivoExcelIniciativas()
{
    this.dataService.descargarArchivoIniciativas(this.paginaActual).subscribe(res => {
        let newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);

       let link = document.createElement('a');
      link.href = data;
      link.download = "MisIniciativas";
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(function () {
        // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });

}
/**************************************************************************************************/
cambiarEstatus(estatus: string) {
  if (estatus === 'Corregir') {
    this.showHistorialAlert = true; // Muestra la alerta en el icono de historial
  } else {
    this.showHistorialAlert = false; // Oculta la alerta si el estatus cambia a otro valor
  }
}
/**************************************************************************************************/

}//cierre clase


  